import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from './locales/en/translation.json';
import translationRU from './locales/ru/translation.json';

const resources = {
  en: {
    translation: translationEN
  },
  ru: {
    translation: translationRU
  },
};

i18n
  .use(LanguageDetector)
  .init({
    resources,
    debug: true,
    lng: navigator.language || navigator.userLanguage,
    fallbackLng: 'en',

    // react i18next special options (optional)
    react: {
      wait: false,
      bindI18n: 'languageChanged loaded',
      bindStore: 'added removed',
    },
  });

export default i18n;


// WEBPACK FOOTER //
// ./src/i18n.js